module.exports = __webpack_public_path__ + "media/components/Sponsors/Settings/Edit/icon-close-a4ac9aea701a547752eaf68bd2079ae1.png";